import ButtonIcon from "components/ButtonIcon/ButtonIcon";
import { Tooltip } from "components/Tooltip/Tooltip";
import { useMemo, useState } from "react";

import GenerateDocumentModal from "./GenerateDocumentModal";
import { useGetMSAByIdQuery } from "services/msa-api";

type GenerateDocumentButtonProps = {
  serviceType: "MSA" | "MCP" | "LCP" | "AMENDED_REVIEW";
  serviceId?: string;
};

const GenerateDocumentButton = ({
  serviceType,
  serviceId,
}: GenerateDocumentButtonProps) => {
  const [showModal, setShowModal] = useState(false);

  const { data: msaData } = useGetMSAByIdQuery(
    { msaId: serviceId },
    { skip: serviceType !== "MSA" || !serviceId },
  );

  const resolvedServiceType = useMemo(() => {
    if (serviceType === "MSA") {
      const type = msaData?.type;
      if (
        type === "Pre-MSA Snapshot" ||
        type === "MSA-111" ||
        type === "Non-Threshold MSA"
      ) {
        return type === "Non-Threshold MSA" ? "NTMSA" : type;
      }
    }
    return serviceType;
  }, [serviceType, msaData]);

  return (
    <>
      <Tooltip content="Generate Document">
        <ButtonIcon kind="neutral" onClick={() => setShowModal(true)}>
          downloading
        </ButtonIcon>
      </Tooltip>

      <GenerateDocumentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        serviceType={resolvedServiceType}
        serviceId={serviceId}
      />
    </>
  );
};

export default GenerateDocumentButton;
